import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`

  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const StyledTitle = styled.span`
  display: block;
  margin: 0 auto;
  margin-top: 5px;
  padding: 0;
  text-align: center;
  font-size: 20px;
  line-height: 1.2;
  animation: ${fadeIn} .3s ease-in;
`;

const Title = props => (
  <StyledTitle>
    {props.children}
  </StyledTitle>
);

Title.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Title;
